import checkForAuthenticatedBotToken from './check-for-authenticated-bot-token';
function setAuthenticatedBotCacheHeader(app, authenticatedBotHeaders, cacheControl) {
  if (!cacheControl) return;
  if (!checkForAuthenticatedBotToken(app, authenticatedBotHeaders)) return;
  app.ctx.res.setHeader('Cache-Control', cacheControl);
}
export default setAuthenticatedBotCacheHeader;
//# sourceMappingURL=set-authenticated-bot-cache-header.js.map